import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.scss']
})
export class PriceComponent {
  price = input<number>();
  priceToShow = computed(() => {
    if (this.type() === 'wholesale') {
      return this.price();
    }

    const price = this.price();
    if (typeof price === 'undefined') {
      return undefined;
    }

    return Math.round(price / 5) * 5;
  })
  type = input<'wholesale' | 'retail' | 'retailer' | 'rounded-only'>();
  nowrap = input(false);
  displayStyle = input<'normal' | 'compact'>();
  priceType = computed(() => !this.type() ? null : this.type());
  typeToShow = computed(()=> {
    const priceType = this.priceType();
    if (this.displayStyle() === 'compact') {
      return priceType === 'wholesale' || priceType === 'retail' ? `${priceType.slice(0,1).toUpperCase()}: ` : priceType;
    }
    return !!priceType ? `(${priceType})` : null;
  });
}
